__turbopack_context__.v({
  "loading": "styles-module-scss-module__Pi5M2q__loading",
  "root": "styles-module-scss-module__Pi5M2q__root",
  "rootWithMargin": "styles-module-scss-module__Pi5M2q__rootWithMargin",
});
